import { jsx as _jsx } from "react/jsx-runtime";
import { FieldWrapper } from '../FieldWrapper';
import classes from './TextFieldWrapper.module.css';
export const TextFieldWrapper = ({ label, children }) => {
    return (_jsx(FieldWrapper, { label: label, children: _jsx("div", { className: classes.container, children: children }) }));
};
